<template>
  <div>
    <div class="mb-20" id="subscriber-list">
      <div class="text-2xl font-bold">
        {{ $t('frontend_groovemail_forms_step4_subscribe') }}
      </div>
      <div class="text-sm mt-2 mb-4 text-grey-700">
        {{ $t('frontend_groovemail_forms_step4_subscribe_which_list_added') }}
      </div>
      <div class="form-content-box p-10">
        <div class="font-semibold mb-2">
          {{ $t('frontend_groovemail_forms_select_assign_list') }}
        </div>
        <div style="width: 400px">
          <treeselect
            :key="1"
            class="h-10 custom-treeselect treeselect-add-new"
            v-model="custommodel.list"
            :multiple="true"
            :options="listData"
            :closeOnSelect="closeOnSelect"
            :clearable="clearable"
            @select="listSelected"
            :clearOnSelect="clearOnSelect"
            @deselect="listRemoved"
            :placeholder="
              $t('frontend_groovemail_campains_step3_select_list')
            "
          />
          <div
            class="text-danger text-sm mt-2"
            v-if="isListSelectionInvalid && selectionSubmitted"
          >
            {{ $t('frontend_groovemail_forms_step4_select_atleast') }}
          </div>
        </div>
      </div>
    </div>

    <div class="mb-20" id="assign-tags">
      <div class="text-2xl font-bold">
        {{ $t('frontend_groovemail_forms_step4_assigntags') }}
      </div>
      <div class="text-sm mt-2 mb-6 text-grey-700">
        {{ $t('frontend_groovemail_forms_step4_assigntags_tagging_helps') }}
      </div>
      <div class="form-content-box p-10 mb-4">
        <gd-custom-radio
          v-model="custommodel.tagassigned"
          class="form-setup-radio"
          :option="tag_options[0]"
          value="custommodel.tagassigned"
          @onUpdateOption="tagOptionsSwitched"
        ></gd-custom-radio>

        <div
          style="width: 360px"
          class="mt-2"
          v-if="custommodel.tagassigned === 'yes'"
        >
          <treeselect
            :key="2"
            class="custom-treeselect treeselect-add-new"
            v-model="custommodel.tag"
            :multiple="true"
            :closeOnSelect="closeOnSelect"
            :clearable="clearable"
            :clearOnSelect="clearOnSelect"
            :options="tagsData"
            @select="tagSelected"
            @deselect="tagRemoved"
            :placeholder="
              $t('frontend_groovemail_campains_step3_select_tag')
            "
          />
        </div>

        <div
          class="text-danger text-sm mt-2"
          v-if="isTagSelectionInvalid && selectionSubmitted"
        >
          {{ $t('frontend_groovemail_forms_step4_select_atleast_one_tag') }}
        </div>
      </div>
      <div class="form-content-box p-10">
        <gd-custom-radio
          v-model="custommodel.tagassigned"
          class="form-setup-radio"
          :option="tag_options[1]"
          value="custommodel.tagassigned"
          @onUpdateOption="tagOptionsSwitched"
        ></gd-custom-radio>
      </div>
    </div>

    <div class="mb-20" id="sequence-list">
      <div class="text-2xl font-bold">
        {{ $t('frontend_groovemail_lead_detail_sequence_tab') }}
      </div>
      <div class="text-sm mt-2 mb-6 text-grey-700">
        {{ $t('frontend_groovemail_lead_detail_sequence_tab_desc') }}
      </div>
      <div class="form-content-box p-10 mb-4">
        <gd-custom-radio
          v-model="custommodel.sequenceassigned"
          class="form-setup-radio"
          :option="sequence_options[0]"
          value="custommodel.sequenceassigned"
          @onUpdateOption="sequenceOptionSwitched"
        ></gd-custom-radio>

<!-- this one -->
        <div
          class="mt-2"
          v-if="custommodel.sequenceassigned === 'yes'"
          style="width: 360px"
        >
          <treeselect
            :key="3"
            class="custom-treeselect"
            v-model="custommodel.sequence"
            :closeOnSelect="closeOnSelect"
            :clearable="clearable"
            :clearOnSelect="clearOnSelect"
            :multiple="true"
            :options="sequenceData"
            @select="sequenceSelected"
            @deselect="sequenceRemoved"
            :placeholder="$t('frontend_automations_select_sequence')"
          />
        </div>

        <div v-if="isSequenceSelectionInvalid && selectionSubmitted">
          <p class="text-danger text-sm mt-2">
            {{ $t('frontend_groovemail_forms_step4_select_atleast_one_sequence') }}
          </p>
        </div>
      </div>
      <div class="form-content-box p-10">
        <gd-custom-radio
          v-model="custommodel.sequenceassigned"
          class="form-setup-radio"
          :option="sequence_options[1]"
          value="custommodel.sequenceassigned"
          @onUpdateOption="sequenceOptionSwitched"
        ></gd-custom-radio>
      </div>
    </div>
    <gd-modal
      name="create-maillist-in-form-modal"
      :title="$t('frontend_groovemail_contacts_step4_create_new_list')"
    >
      <create-list
        :type="'add'"
        :mail_list_id="null"
        :mail_list_data="mail_list_data"
        @showLoader="showLoader"
        @hideLoader="hideLoader"
        @fetchEventsList="fetchEventsList"
        @closeCreateMaillistModal="closeCreateMaillist"
      >
      </create-list>
    </gd-modal>

    <gd-modal
      name="create-mailtag-in-form-modal"
      :title="$t('frontend_groovemail_contacts_step4_create_newtag')"
    >
      <create-tag
        :type="'add'"
        :mail_tag_id="null"
        :mail_tag_data="mail_tag_data"
        @showLoader="showLoader"
        @hideLoader="hideLoader"
        @fetchTags="fetchEventsTags"
        @closeCreateTagsModal="closeCreateMailtag"
      ></create-tag>
    </gd-modal>
  </div>
</template>

<script>
import axios from 'axios';
import Treeselect from '@riophae/vue-treeselect';
import Mailtag from '@/models/Mailtag';
import Mailsequence from '@/models/Mailsequence';

import CreateList from '@/components/create-lists.vue';
import CreateTag from '@/components/create-tags.vue';

import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'Step4',
  props: {
    model: {
      required: true,
    },
  },

  data() {
    return {
      clearable: false,
      closeOnSelect: true,
      clearOnSelect: true,
      selectionSubmitted: false,
      isListSelectionInvalid: false,
      isTagSelectionInvalid: false,
      isSequenceSelectionInvalid: false,
      localModel: this.model,
      lists: [],
      tags: [],
      sequences: [],
      custommodel: {
        list: [],
        tag: [],
        sequence: [],
        tagassigned: '',
        listassigned: '',
        sequenceassigned: '',
      },
      mail_list_data: { name: '', description: '' },
      mail_tag_data: {
        name: '',
        description: '',
        category: [],
        categoryname: '',
      },
    };
  },

  computed: {
    tag_options() {
      return [
        {
          id: 'yes',
          title: this.$t('frontend_groovemail_forms_step4_yes_assign_tag'),
          description: this.$t('frontend_groovemail_forms_step4_yes_assign_tag_desc'),
        },
        {
          id: 'no',
          title: this.$t('frontend_groovemail_forms_step4_dont_assign_tag'),
          description: this.$t('frontend_groovemail_forms_step4_dont_assign_tag_desc'),
        },
      ];
    },

    sequence_options() {
      return [
        {
          id: 'yes',
          title: this.$t('frontend_groovemail_forms_step4_yes_assign_sequence'),
          description: this.$t('frontend_groovemail_forms_step4_yes_assign_sequence_desc'),
        },
        {
          id: 'no',
          title: this.$t('frontend_groovemail_forms_step4_dont_assign_sequence'),
          description: this.$t('frontend_groovemail_forms_step4_dont_assign_sequence_desc'),
        },
      ];
    },

    listData() {
      const listData = [];
      if (this.lists && this.lists.length) {
        this.lists.forEach((element) => {
          listData.push({ id: element.id, label: element.name });
        });
      }
      const listIndex = listData.findIndex((listEle) => {
        return listEle.id === 'createListOption1';
      });
      if (listIndex < 0) {
        listData.push({
          id: 'createListOption1',
          label: this.$t('frontend_groovemail_mail_list_newlist'),
        });
      }
      return listData;
    },

    tagsData() {
      const tagsData = [];
      if (this.tags && this.tags.length) {
        this.tags.forEach((element) => {
          tagsData.push({ id: element.id, label: element.name });
        });
      }
      const tagIndex = tagsData.findIndex((tagEle) => {
        return tagEle.id === 'createTagOption1';
      });
      if (tagIndex < 0) {
        tagsData.push({
          id: 'createTagOption1',
          label: this.$t('frontend_groovemail_mail_tag_new_tag'),
        });
      }
      return tagsData;
    },

    sequenceData() {
      const sequenceData = [];
      if (this.sequences && this.sequences.length) {
        this.sequences.forEach((element) => {
          sequenceData.push({ id: element.id, label: element.name });
        });
      }
      return sequenceData;
    },
  },

  components: {
    Treeselect,
    CreateList,
    CreateTag,
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },

    // Watch for changes to the length of the 'assigntags' array in 'localModel'
    'localModel.assigntags.length': function assignTagsLengthWatcher() {
      // Call the 'tagOptionsSwitched' method to update the tag options
      this.tagOptionsSwitched();
      // Call the 'checkStepValidity' method to check the validity of the current step
      this.checkStepValidity();
    },

    // Watch for changes to the length of the 'assignsequences' array in 'localModel'
    'localModel.assignsequences.length': function assignSequencesLengthWatcher() {
      // Call the 'sequenceOptionSwitched' method to update the sequence options
      this.sequenceOptionSwitched();
      // Call the 'checkStepValidity' method to check the validity of the current step
      this.checkStepValidity();
    },

    // Watch for changes to the 'list' property in 'custommodel'
    'custommodel.list': function customModelListWatcher() {
      // If the 'list' property is defined and not empty
      if (this.custommodel.list && this.custommodel.list.length) {
        // Find the index of the 'createListOption1' element in the 'list' array
        const listIndex = this.custommodel.list.findIndex((ele) => {
          return ele === 'createListOption1';
        });
        // If the 'createListOption1' element is found in the 'list' array
        if (listIndex >= 0) {
          // Remove the 'createListOption1' element from the 'list' array
          this.custommodel.list.splice(listIndex, 1);
        }
      }
    },

    // Watch for changes to the 'tag' property in 'custommodel'
    'custommodel.tag': function customModelTagWatcher() {
      // If the 'tag' property is defined and not empty
      if (this.custommodel.tag && this.custommodel.tag.length) {
        // Find the index of the 'createTagOption1' element in the 'tag' array
        const tagIndex = this.custommodel.tag.findIndex((ele) => {
          return ele === 'createTagOption1';
        });
        // If the 'createTagOption1' element is found in the 'tag' array
        if (tagIndex >= 0) {
          // Remove the 'createTagOption1' element from the 'tag' array
          this.custommodel.tag.splice(tagIndex, 1);
        }
      }
    },

    // Watch for changes to the 'tagassigned' property in 'custommodel'
    'custommodel.tagassigned': function tagassigned() {
      // Call the 'checkStepValidity' method to check the validity of the current step
      this.checkStepValidity();
    },

    // Watch for changes to the 'sequenceassigned' property in 'custommodel'
    'custommodel.sequenceassigned': function customModelSequenceAssignedWatcher() {
      // Call the 'checkStepValidity' method to check the validity of the current step
      this.checkStepValidity();
    },
  },

  async created() {   
    try {
      this.showLoader();
      const mailLists = await axios.get(`/maillistonly`);
      this.lists = mailLists?.data?.data;
      this.tags = await Mailtag.$get();
      this.sequences = await Mailsequence.$get();
      
      this.custommodel.tagassigned =
        this.localModel.assigntags.length > 0 ? 'yes' : 'no';
      this.custommodel.listassigned =
        this.localModel.assignlists.length > 0 ? 'yes' : 'no';
      this.custommodel.sequenceassigned =
        this.localModel.assignsequences.length > 0 ? 'yes' : 'no';
  
      if (this.localModel.assignlists && this.localModel.assignlists.length) {
        this.localModel.assignlists.forEach((ele) => {
          const listIndex = this.custommodel.list.findIndex((listEle) => {
            return ele.id === listEle;
          });
          if (listIndex < 0) {
            this.custommodel.list.push(ele.id);
          }
        });
      }
      if (this.localModel.assigntags && this.localModel.assigntags.length) {
        this.localModel.assigntags.forEach((ele) => {
          const tagIndex = this.custommodel.tag.findIndex((tagEle) => {
            return ele.id === tagEle;
          });
          if (tagIndex < 0) {
            this.custommodel.tag.push(ele.id);
          }
        });
      }
      if (
        this.localModel.assignsequences &&
        this.localModel.assignsequences.length
      ) {
        this.localModel.assignsequences.forEach((ele) => {
          const sequenceIndex = this.custommodel.sequence.findIndex(
            (sequenceEle) => {
              return ele.id === sequenceEle;
            }
          );
          if (sequenceIndex < 0) {
            this.custommodel.sequence.push(ele.id);
          }
        });
      }
  
      this.hideLoader();
    } catch (error) {
      // show error alert
      this.$emit('requestErrorAlert', error.response?.data?.error);
    }
  },

  methods: {

    /**
     * Checks whether the current step is valid by checking the validity of the list, tag, and sequence selections.
     * Emits a 'dataValid' event with the validity status.
    */
    checkStepValidity() {
      const isStepValid =
        this.isListSelectionInvalid === true ||
        this.isTagSelectionInvalid === true ||
        this.isSequenceSelectionInvalid === true
          ? false
          : true;
      this.$emit('dataValid', isStepValid);
    },

    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    listSelected(node) {
      if (node.id !== 'createListOption1') {
        this.localModel.assignlists.push({
          id: node.id,
          name: node.label,
        });
      } else {
        this.openCreateListModal();
      }
      this.validateListAdded();
    },

    openCreateListModal() {
      this.mail_list_data.name = '';
      this.mail_list_data.description = '';
      this.$root.$emit('modal-open', 'create-maillist-in-form-modal');
    },

    async fetchEventsList(listData) {
      // show loader
      this.showLoader();

      try {
        const mailLists = await axios.get(`/maillistonly`);
        this.lists = mailLists?.data?.data;
        if (listData && listData.data && listData.data.id) {
          this.custommodel.list.push(listData.data.id);
          this.localModel.assignlists.push({
            id: listData.data.id,
            name: listData.data.name,
          });
          this.validateListAdded();
        }

        // hide loader
        this.hideLoader();
      } catch (error) {
        // show error alert
        this.$emit('requestErrorAlert', error.response?.data?.error);
      }
    },

    closeCreateMaillist() {
      this.$root.$emit('modal-close', 'create-maillist-in-form-modal');
    },

    listRemoved(node) {
      const listIndex = this.localModel.assignlists.findIndex((ele) => {
        return ele.id === node.id;
      });
      this.localModel.assignlists.splice(listIndex, 1);
      this.validateListAdded();
    },

    tagSelected(node) {
      if (node.id !== 'createTagOption1') {
        this.localModel.assigntags.push({
          id: node.id,
          name: node.label,
        });
      } else {
        this.openCreateTagModal();
      }
      this.tagOptionsSwitched();
    },

    openCreateTagModal() {
      this.mail_tag_data.name = '';
      this.mail_tag_data.description = '';
      this.mail_tag_data.category = [];
      this.mail_tag_data.categoryname = '';
      this.$root.$emit('modal-open', 'create-mailtag-in-form-modal');
    },

    async fetchEventsTags(tagData) {
      // show loader
      this.showLoader();

      try {
        this.tags = await Mailtag.$get();
        if (tagData && tagData.data && tagData.data.id) {
          this.custommodel.tag.push(tagData.data.id);
          this.localModel.assigntags.push({
            id: tagData.data.id,
            name: tagData.data.name,
          });
          this.tagOptionsSwitched();
        }

        // hide loader
        this.hideLoader();
      } catch (error) {
        // show error alert
        this.$emit('requestErrorAlert', error.response?.data?.error);
      }
    },

    closeCreateMailtag() {
      this.$root.$emit('modal-close', 'create-mailtag-in-form-modal');
    },

    tagRemoved(node) {
      const tagIndex = this.localModel.assigntags.findIndex((ele) => {
        return ele.id === node.id;
      });
      this.localModel.assigntags.splice(tagIndex, 1);
      this.tagOptionsSwitched();
    },

    sequenceSelected(node) {
      this.localModel.assignsequences.push({
        id: node.id,
        name: node.label,
      });
      this.sequenceOptionSwitched();
    },

    sequenceRemoved(node) {
      const sequenceIndex = this.localModel.assignsequences.findIndex((ele) => {
        return ele.id === node.id;
      });
      this.localModel.assignsequences.splice(sequenceIndex, 1);
      this.sequenceOptionSwitched();
    },

    sequenceOptionSwitched() {
      if (this.custommodel.sequenceassigned === 'no') {
        this.custommodel.sequence = [];
        this.localModel.assignsequences = [];
      }
      this.isSequenceSelectionInvalid =
        (this.custommodel.sequenceassigned === 'yes' &&
          this.localModel.assignsequences &&
          this.localModel.assignsequences.length > 0) ||
        this.custommodel.sequenceassigned === 'no'
          ? false
          : true;
    },

    tagOptionsSwitched() {
      if (this.custommodel.tagassigned === 'no') {
        this.custommodel.tag = [];
        this.localModel.assigntags = [];
      }
      this.isTagSelectionInvalid =
        (this.custommodel.tagassigned === 'yes' &&
          this.localModel.assigntags &&
          this.localModel.assigntags.length > 0) ||
        this.custommodel.tagassigned === 'no'
          ? false
          : true;
    },

    validateListAdded() {
      if (this.localModel.assignlists && this.localModel.assignlists.length) {
        this.isListSelectionInvalid = false;
      } else {
        this.isListSelectionInvalid = true;
      }
    },

    validateBeforeSubmit() {
      this.validateListAdded();
      this.tagOptionsSwitched();
      this.sequenceOptionSwitched();
      const isValid =
        this.isListSelectionInvalid === true ||
        this.isTagSelectionInvalid === true ||
        this.isSequenceSelectionInvalid === true
          ? false
          : true;
      return { isValid: isValid, customModel: this.custommodel };
    },

    validate() {
      this.selectionSubmitted = true;
      return this.validateBeforeSubmit();
    },
  },
};
</script>

<style lang="scss">
.form-setup-radio.flex {
  margin: 0;
  padding: 0;
  border: none;
  height: auto;
  position: relative;
  .ml-2 {
    margin: 0;
    label {
      color: #191d3a;
    }
    .text-grey-500 {
      font-size: 14px;
      line-height: 24px;
      color: #545671;
      margin-top: 8px;
    }
  }
  .w-6 {
    height: 24px;
    margin: 0;
    position: absolute;
    right: 0;
    top: 16px;
  }
}
</style>
